import { render, staticRenderFns } from "./BackorderOptions.vue?vue&type=template&id=28eb7e8a"
import script from "./BackorderOptions.ts?vue&type=script&lang=ts&external"
export * from "./BackorderOptions.ts?vue&type=script&lang=ts&external"
import style0 from "./BackorderOptions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports